// SettingsIntegrationsPane.jsx

import React, { useState } from 'react';

// Components
import SettingsModalPaneHeader from './SettingsModalPaneHeader';
import SettingsModalPaneContents from './SettingsModalPaneContents';
import Api from 'pages/Api';

/**
 * SettingsIntegrationsPane
 *
 * Renders API and other third-party integration controls for the space.
 * Connected sources (Gmail, Drive, etc.) are managed from Settings → Sources.
 */
const SettingsIntegrationsPane = React.memo(() => {
  const [headerActions, setHeaderActions] = useState(null);

  return (
    <>
      <SettingsModalPaneHeader
        title="API"
        subtitle="Manage third-party integrations connected to this knowledge base."
        rightContent={headerActions}
      />

      <SettingsModalPaneContents>
        <div className="settings-modal-embedded-panel">
          <Api
            hideHeader
            onHeaderActionsChange={setHeaderActions}
          />
        </div>
      </SettingsModalPaneContents>
    </>
  );
});

SettingsIntegrationsPane.displayName = 'SettingsIntegrationsPane';

export default SettingsIntegrationsPane;
